import React,{useRef} from 'react'
import './AHeader.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { LoginService } from './services/LoginService';
import useEffectOnce from './hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './reducers';

import { Divider } from 'primereact/divider';
type Nullable<T> = T | null;

// var imageName = require('./assets/img/gfn.png');
var imageuser = require('./assets/img/userim.png');

var imageuser1 = require('./assets/img/medi.png');
var projecticon = require('./assets/img/medicaaal.png');

export const AHeader = () => {
    const op = useRef(null as any);
    const sessionphoto = window.sessionStorage.getItem('photo');
    const uid = window.sessionStorage.getItem('uid');
    const userid = window.sessionStorage.getItem('userid');
  
    // const headerdata = useSelector((state: RootState) => state.dprofile.headerdata)
  
  
    const imgSrc =  imageuser;
  
    const usertype = window.sessionStorage.getItem('usertype');
  
    const handleLogout = () => {
      window.sessionStorage.removeItem('usertype');
  
  
  
  
    };
  



  return (

       <div className="layout-topbar">
      <div className="layout-topbar-logo" >
        <span>
        <img src={imageuser1} alt="Logo" width="50px" height="100%" />
        <img src={projecticon} alt="Logo" width="200px" height="100%" />
        </span>
        
      </div>
      <div className="col-6">
        <div className="mb-3 font-bold text-2xl">
        </div>
      </div>
      <ul className="navbar-nav ml-auto">
        <a  className="nav-link" onClick={(e) => op.current.toggle(e)} style={{ textDecoration: 'none' }}>
            <img src={imageuser} className="avatar" alt="User Image" style={{width:'40px',height:'40px',marginRight:'5px',fontWeight:'400',fontSize:'16px'}} />
            <span className="hidden-xs" style={{ color: '#818ea1', textDecoration: 'none !important'}}>admin</span>

          </a>
        <OverlayPanel ref={op}>
          <div className="dropdown-divider"></div>
          <a className="dropdown-item">
            
            <div className="media">
              <a href="/" onClick={handleLogout} >Sign out</a>
            </div>
          </a>
        </OverlayPanel>
      </ul>
    </div>
  )
}
AHeader.displayName = 'AppTopbar';

